export default __webpack_public_path__ + "static/media/image-board-study-pattern-n-m@3x.393e2968.webp";